<template>
  <cs-preloader-overlay :loading="loading">
    <div class="overlay-container">
      <modal-cabinet-qr-code />

      <div class="main-container">
        <div class="header-container">
          <capusta-title :title="$t('ready.for.pay')" icon-outside />
        </div>

        <div class="form-container">
          <div class="section-container">
            <substrate-mount>
              <div class="input-container">
                <capusta-copy-field :label="$t('link.to.pay')" :value="billParams.url" />
              </div>
              <div v-if="isShownMakerPublishing" class="switcher-container">
                <cs-switcher
                  v-model="onMarketplace"
                  :label="$t('publishing.to.maker')"
                  @input="onToggleMarketplace"
                />
              </div>
              <div v-if="promoCodeApplicable" class="switcher-container">
                <cs-switcher
                  :label="$t('allow.promocode.usage')"
                  :value="applyPromoCode"
                  @input="onTogglePromoCodePermission"
                />
                <!-- TODO: временно скрываем текст с информацией о промокоде -->
                <!-- <div
                  v-if="applyPromoCode"
                  class="promocode-details-container"
                  v-html="displayPromoCodeMessage"
                ></div> -->
              </div>
              <div
                v-if="onMarketplace"
                class="option-container"
                @click.prevent="onChangeMarketplaceCategory"
              >
                <option-panel :option="currentCategory" noactive>
                  <cs-button type="secondary">{{ $t('common.change') }}</cs-button>
                </option-panel>
              </div>
              <div class="input-container">
                <input-email
                  ref="email"
                  v-model="email"
                  input-id="input-email"
                  :input-name="$t('send.to.email')"
                  :input-title="$t('indicate.electronic.mail')"
                  :input-header="$t('send.to.email')"
                  :input-placeholder="$t('enter.email')"
                  :button-text="$t('common.send')"
                  required
                  @buttonClicked="sendBill"
                />
              </div>
              <div class="option-container">
                <socials-share
                  :url="billParams && billParams.url"
                  :description="PROJECT_INFO.description || ''"
                  :title="`${$t('link.to.pay')} | capusta.space`"
                >
                  <button
                    type="button"
                    class="button social qr"
                    @click.prevent="
                      SET_MODAL_PARAMS({
                        type: 'QR',
                        params: {
                          show: true,
                          bill: billParams,
                          type: 'bill',
                          code: billParams.code,
                        },
                      })
                    "
                  >
                    <span>{{ $t('get.qr') }}</span>
                  </button>
                </socials-share>
              </div>
            </substrate-mount>
          </div>

          <div class="button-primary-container">
            <cs-button :width="300" @click="$router.push({ name: 'Invoicing' })">
              {{ $t('create.new') }}
            </cs-button>
          </div>

          <div class="button-secondary-container">
            <cs-button type="secondary" :width="200" @click="$router.push({ name: 'cabinet' })">
              {{ $t('to.main.page') }}
            </cs-button>
          </div>
        </div>
      </div>

      <cs-dialog v-model="isShownMarketplaceCategories">
        <dialog-list-layout>
          <option-panel
            v-for="category in getPreparedCategories"
            :key="category.id"
            :option="category"
            @click="onCloseMarketplaceCategories"
          />
        </dialog-list-layout>
      </cs-dialog>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

import DialogListLayout from 'modules/Dialogs/ListLayout';
import CapustaTitle from 'modules/CapustaLayout/CapustaTitle';

import SubstrateMount from '@/components/capusta/SubstrateMount';
import CapustaCopyField from '@/components/capusta/CopyField';

import InputEmail from '@/components/inputElements/InputEmail';
import ModalCabinetQrCode from '@/components/modals/ModalCabinetQrCode';
import SocialsShare from '@/components/otherElements/SocialsShare';

import OptionPanel from '@/components/capusta/OptionPanel';

import { DEFAUL_CATEGORY_CODE } from './const';

export default {
  name: 'InvoicingResult',
  components: {
    CapustaTitle,
    SubstrateMount,
    InputEmail,
    SocialsShare,
    ModalCabinetQrCode,
    OptionPanel,
    DialogListLayout,
    CapustaCopyField,
  },
  props: {
    billParams: {
      type: Object,
      required: true,
    },
    showQr: {
      type: Boolean,
      default: () => false,
    },
  },
  async created() {
    if (!this.billParams || !this.billParams.id) {
      return this.$router.go(-1);
    }

    await this.loadData();

    if (!this.showQr) {
      return;
    }

    setTimeout(() => {
      this.SET_MODAL_PARAMS({
        type: 'QR',
        params: {
          show: true,
          type: 'bill',
          bill: this.billParams,
          code: this.billParams.code,
        },
      });
    }, 1000);
  },
  data() {
    return {
      email: '',
      loading: false,
      onMarketplace: false,
      isShownMarketplaceCategories: false,
      categoryCode: DEFAUL_CATEGORY_CODE,
      applyPromoCode: false,
      promoCodeDetails: null,
    };
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    isValid() {
      return !this.email || this.$refs.email.$v.$error ? false : true;
    },
    currentCategory() {
      const category = this.MARKETPLACE_CATEGORIES.find(
        category => category.code === this.categoryCode
      );

      return {
        ...category,
        label: this.$t('common.category'),
        description: this.$t(category.description),
      };
    },
    getPreparedCategories() {
      return this.MARKETPLACE_CATEGORIES.map(category => {
        return {
          id: category.id,
          code: category.code,
          description: this.$t(category.description),
          active: category.id === this.currentCategory.id,
        };
      });
    },
    requestData() {
      return {
        onMarketplace: this.onMarketplace,
        marketplaceCategoryId: this.currentCategory.id,
      };
    },
    promoCodeApplicable() {
      if (this.isTips) {
        return false;
      }

      return this.billParams?.promoCodeApplicable;
    },
    displayPromoCodeMessage() {
      if (this.$validate.isNull(this.promoCodeDetails)) {
        return '';
      }

      const formattedDiscount = this.$validate.isNull(this.promoCodeDetails.discountPercent)
        ? formatAmount(this.promoCodeDetails.discountAmount, this.currency)
        : `${this.promoCodeDetails.discountPercent}%`;

      const formattedAmountWithDiscount = formatAmount(this.promoCodeDetails.amountWithDiscount, this.currency);

      return this.$t('payer.can.use.promocode', {
        promoCode: this.promoCodeDetails.code,
        formattedDiscount,
        formattedAmountWithDiscount,
      });
    },
    isTips() {
      return this.billParams?.type === 'TIPS';
    },
    isShownMakerPublishing() {
      if (this.isTips) {
        return false;
      }

      return this.makerPublishingPermission;
    },
    ...mapState(['PROJECT_INFO']),
    ...mapGetters(['MARKETPLACE_CATEGORIES', 'makerPublishingPermission']),
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.FETCH_MARKETPLACE_CATEGORIES();
      await this.loadPromoCodeDetails();
      this.loading = false;
    },
    copy() {
      this.$copyText(this.$refs.billLink.innerText);

      this.$alert({
        type: 'ok',
        text: 'link.copied:',
      });
    },
    sendBill() {
      if (!this.isValid) {
        return this.$alert({
          type: 'warning',
          text: 'mistakes.in.form',
        });
      }

      HTTPService.sendReceipt(this.billParams.id, { recipient: this.email })
        .then(() => {
          this.email = '';
          this.$refs.email.$v.$reset();

          this.$alert({
            type: 'golubok',
            text: 'bill.sent.to.email',
          });
        })
        .catch(error => {
          logrocket.logger(error);

          this.$alert({
            type: 'warning',
            text: 'error.in.system.try.later',
          });
        });
    },
    onToggleMarketplace() {
      HTTPService.editBill(
        this.requestData,
        this.billParams.code
      )
        .then(response => {
          // eslint-disable-next-line no-console
          console.log('response success', response);
        })
        .catch(error => {
          logrocket.logger(error);
        });
    },
    onChangeMarketplaceCategory() {
      this.isShownMarketplaceCategories = true;
    },
    async onCloseMarketplaceCategories(category) {
      this.categoryCode = category.code;

      await this.onToggleMarketplace();

      this.isShownMarketplaceCategories = false;
    },
    async loadPromoCodeDetails() {
      if (!this.promoCodeApplicable) {
        return;
      }

      try {
        const { data } = await HTTPService.getBillPromoCodeDetails(this.billParams.code);

        this.promoCodeDetails = data;
        this.applyPromoCode = this.billParams?.applyPromoCode;
      } catch (error) {
        logrocket.logger(error);
      }
    },
    async onTogglePromoCodePermission() {
      try {
        const { data } = await HTTPService.editBill(
          { applyPromoCode: !this.applyPromoCode },
          this.billParams.code
        );

        this.applyPromoCode = data.applyPromoCode;

        this.$alert({
          type: 'ok',
          text: data.applyPromoCode
            ? 'promocode.usage.is.allowed'
            : 'promocode.usage.is.denied',
        });
      } catch (error) {
        logrocket.logger(error);

        this.$alert({
          type: 'warning',
          text: 'promocode.usage.is.impossible',
        });
      }
    },
    ...mapActions(['FETCH_MARKETPLACE_CATEGORIES']),
    ...mapMutations(['SET_MODAL_PARAMS']),
  },
};
</script>

<style lang="sass" scoped>
  .overlay-container
    overflow: hidden

  .main-container
    width: 100%
    max-width: 500px
    position: relative
    margin: 0 auto
    padding: 20px 0 60px

    +respond-to('medium')
      padding: 70px 0

    &::before
      content: ''
      width: 18rem
      height: 10rem
      display: block
      position: absolute
      top: 0
      right: 0
      background-image: url('~@/assets/svg/mobile/bill/gradient-stars.svg')
      background-repeat: no-repeat
      background-size: cover
      z-index: -1

      +respond-to('small')
        width: 20rem
        height: 15rem
        background-image: url('~@/assets/svg/bill/gradient-stars.svg')

      +respond-to('medium')
        width: 40rem
        height: 33rem
        top: -10px
        right: -22rem

  .header-container
    margin-bottom: 20px
    padding: 0 20px

    +respond-to('small')
      margin-bottom: 30px
      padding: 0

  .form-container
    width: 100%
    max-width: 500px
    position: relative
    margin: 0 auto

  .input-container
    &:not(:last-child)
      margin-bottom: 20px

    .input,
    .textarea
      margin: 0
      white-space: nowrap

  .section-container
    margin-bottom: 20px

  .switcher-container
    &.error
      display: flex
      align-items: center
      justify-content: space-between

  .button-primary-container
    display: flex
    justify-content: center
    margin-bottom: 20px

  .button-secondary-container
    display: flex
    justify-content: center

  .promocode-details-container
    margin: 12px 0 0 60px
    padding: 10px
    font-size: 12px
    line-height: 16px
    background-color: #1E1D2F
    border-radius: 0 8px 8px 8px

    &.error
      color: #fff
      background-color: #FF5172
</style>
